/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateOrUpdateEmployerCommand } from '../models/create-or-update-employer-command';
import { EmployerData } from '../models/employer-data';
import { RemoveEmployerCommand } from '../models/remove-employer-command';

@Injectable({
  providedIn: 'root',
})
export class EmployersService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation employersGet
   */
  static readonly EmployersGetPath = '/api/Employers/Get';

  /**
   * Munkáltatók lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `employersGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  employersGet$Plain$Response(params?: {
    Search?: string;
    OrderColumns?: Array<string>;
    PageIndex?: number;
    PageSize?: number;
    MaxPageSize?: number;
    SkipTotalItemCount?: boolean;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<EmployerData>>> {

    const rb = new RequestBuilder(this.rootUrl, EmployersService.EmployersGetPath, 'get');
    if (params) {
      rb.query('Search', params.Search, {});
      rb.query('OrderColumns', params.OrderColumns, {});
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('MaxPageSize', params.MaxPageSize, {});
      rb.query('SkipTotalItemCount', params.SkipTotalItemCount, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<EmployerData>>;
      })
    );
  }

  /**
   * Munkáltatók lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `employersGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  employersGet$Plain(params?: {
    Search?: string;
    OrderColumns?: Array<string>;
    PageIndex?: number;
    PageSize?: number;
    MaxPageSize?: number;
    SkipTotalItemCount?: boolean;
  },
  context?: HttpContext

): Observable<Array<EmployerData>> {

    return this.employersGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<EmployerData>>) => r.body as Array<EmployerData>)
    );
  }

  /**
   * Munkáltatók lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `employersGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  employersGet$Response(params?: {
    Search?: string;
    OrderColumns?: Array<string>;
    PageIndex?: number;
    PageSize?: number;
    MaxPageSize?: number;
    SkipTotalItemCount?: boolean;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<EmployerData>>> {

    const rb = new RequestBuilder(this.rootUrl, EmployersService.EmployersGetPath, 'get');
    if (params) {
      rb.query('Search', params.Search, {});
      rb.query('OrderColumns', params.OrderColumns, {});
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('MaxPageSize', params.MaxPageSize, {});
      rb.query('SkipTotalItemCount', params.SkipTotalItemCount, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<EmployerData>>;
      })
    );
  }

  /**
   * Munkáltatók lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `employersGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  employersGet(params?: {
    Search?: string;
    OrderColumns?: Array<string>;
    PageIndex?: number;
    PageSize?: number;
    MaxPageSize?: number;
    SkipTotalItemCount?: boolean;
  },
  context?: HttpContext

): Observable<Array<EmployerData>> {

    return this.employersGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<EmployerData>>) => r.body as Array<EmployerData>)
    );
  }

  /**
   * Path part for operation employersPost
   */
  static readonly EmployersPostPath = '/api/Employers/Post/Post';

  /**
   * Munkáltató létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `employersPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  employersPost$Response(params?: {
    body?: CreateOrUpdateEmployerCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, EmployersService.EmployersPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Munkáltató létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `employersPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  employersPost(params?: {
    body?: CreateOrUpdateEmployerCommand
  },
  context?: HttpContext

): Observable<void> {

    return this.employersPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation employersRemove
   */
  static readonly EmployersRemovePath = '/api/Employers/Remove/Remove';

  /**
   * Munkáltató törlése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `employersRemove()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  employersRemove$Response(params?: {
    body?: RemoveEmployerCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, EmployersService.EmployersRemovePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Munkáltató törlése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `employersRemove$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  employersRemove(params?: {
    body?: RemoveEmployerCommand
  },
  context?: HttpContext

): Observable<void> {

    return this.employersRemove$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
